import { render } from "./Home.vue?vue&type=template&id=dce25880&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=dce25880&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dce25880"

export default script